module.exports = __webpack_public_path__ + "static/img/cabecera.09e5667.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/components/quienes-somos/cabecera.jpg
// module id = zg+3
// module chunks = 0